import { render } from "./DeleteModal.vue?vue&type=template&id=3407d459&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=3407d459&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3407d459"]])

export default __exports__